import { gql } from '@apollo/client';
import { ConversationThreadFragment } from './fragments';

export const GET_ENTITY_CONVERSATION_THREADS = gql`
  query GetEntityConversationThreads($ids: [ConversationEntityInput!]!) {
    entityConversationThreads(ids: $ids) {
      ...ConversationThreadFields
    }
  }
  ${ConversationThreadFragment}
`;
